import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store/configure';

import Importer from './importer';
import { keyBy } from 'lodash';

export default class ImportsIndex extends React.Component {
  static propTypes = {
    creatingRunRecords: PropTypes.bool.isRequired,
    databaseCurrentStep: PropTypes.string.isRequired,
    databaseDisabledSteps: PropTypes.array.isRequired,
    databaseStepLabels: PropTypes.object.isRequired,
    databaseStepLinks: PropTypes.object.isRequired,
    databaseStepTitles: PropTypes.object.isRequired,
    import: PropTypes.object.isRequired,
    importReverted: PropTypes.bool.isRequired,
    mapperTypeOptions: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    selectedFileId: PropTypes.number,
  }

  store = configureStore({
    importObject: {
      ...this.props.import,
      files: keyBy(this.props.import.files, file => file.id)
    },
    paths: this.props.paths,
    runRecords: {
      creatingRunRecords: this.props.creatingRunRecords,
      headers: [],
      loadingRecords: false,
      editingRecord: {
        id: null
      },
      meta: {
        pageSize: 0,
        currentPage: 0,
        totalPages: 0,
        totalCount: 0
      },
      recordPage: 1,
      records: {},
      recordIds: [],
      importSummary: {
        created: 0,
        updated: 0,
        failed: 0,
        skipped: 0
      }
    },
    static: {
      mapperTypeOptions: this.props.mapperTypeOptions
    },
    ui: {
      currentStep: this.props.databaseCurrentStep,
      disabledSteps: this.props.databaseDisabledSteps,
      importStatus: 0,
      importReverted: this.props.importReverted,
      stepLabels: this.props.databaseStepLabels,
      stepLinks: this.props.databaseStepLinks,
      stepTitles: this.props.databaseStepTitles,
      selectedFileId: this.props.selectedFileId,
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <Importer />
      </Provider>
    );
  }
}
